@if (item) {
  <div class="flex flex-row justify-between flex-nowrap center-v pt-3 pb-3">
    <div class="flex flex-col flex-nowrap pl-3 pr-3 border-box">
      <div class="g custom-grid">
        <div class="flex items-center gap-2">
          <span class="text-sm color-light">
            {{ item.itemScanBean?.artikel?.nummer }}
          </span>
          <soft-serial-number-view [serialNumber]="$safeNavigationMigration(item?.seriennr)" />
        </div>

        <div>
          @if ((item?.files || []).length > 0) {
            <i class="fa-regular fa-images info-icon"></i>
          }
        </div>

        <div class="flex gap-1 items-center flex-grow text-ellipsis overflow-hidden whitespace-nowrap">
          @if ((item?.vermerk || '').length > 0) {
            <i class="fa-regular fa-note-sticky info-icon"></i>
          }
          <div class="text-ellipsis overflow-hidden opacity-70">{{ item?.vermerk }}</div>
        </div>
      </div>
      <div class="mt-1 mb-1">
        @if (item.itemScanBean.artikel.artbez1?.length) {
          <p class="text-base font-semibold">{{ item.itemScanBean.artikel.artbez1 }}</p>
        }
        @if (item.itemScanBean.artikel.artbez2?.length) {
          <p class="text-base text-light">{{ item.itemScanBean.artikel.artbez2 }}</p>
        }
        @if (item.itemScanBean.artikel.artbez3?.length) {
          <p class="text-base text-light">{{ item.itemScanBean.artikel.artbez3 }}</p>
        }
      </div>
    </div>
    <div class="flex flex-row justify-end flex-nowrap center-v pl-3 border-box">
      <div class="flex relative">
        <ng-container>
          <soft-number-input placeholder="Menge"
                             [value]="item.itemScanBean?.menge ?? null"
                             [class.error]="hasError"
                             changeTrigger="input"
                             style="max-width: 80px"
                             (valueChange)="onChange(item, menge.value(), item.itemScanBean.einheit)"
                             #menge>
          </soft-number-input>
          <div style="width: 100px;" class="ml-2">
            <span class="soft-title ml-3 color-light"
                  style="width: 100px">{{ item.itemScanBean.einheit.arteh || ''}}</span>
          </div>
        </ng-container>
      </div>
      <div class="detail-area ml-4" (click)="onEditBeweClick(item)">
        <i class="fa-regular fa-ellipsis-vertical"></i>
      </div>
      <span class="detail-area">
        <i class="fa-regular fa-delete-left pointer p-1"
           [ngStyle]="{ 'color': (!!(item.itemScanBean?.menge) || !!menge?.value()) ? 'var(--colorError)' : 'rgba(0, 0, 0, 0.33)'}"
           (click)="onDeleteBeweClick(item); menge.value.set(null)"></i>
      </span>
    </div>
  </div>
}
